export const PROSPECT_TYPES = ["Property buyer", "Property investor", "Plot buyer", "Residential investor", "Commercial investor",
  "Luxury-property buyer", "Second-home buyer", "NRI investor", "Retirement-property buyer", "Rental-yield investor", "Land investor",
  "Business owner", "Founder", "Company director", "CXO or senior professional", "Doctor or established professional",
  "Existing real-estate investor", "Channel partner", "Custom"];

export const PROPERTY_TYPES = ["Residential apartment", "Villa", "Independent house", "Residential plot", "Commercial property", "Shop",
  "Office", "Hotel", "Resort", "Warehouse", "Agricultural land", "Industrial land", "Holiday home", "Retirement home", "Custom"];

export const SOURCES = [
  { key: "general_web", label: "General web" },
  { key: "business_websites", label: "Public business websites" },
  { key: "professional_pages", label: "Public professional pages" },
  { key: "linkedin", label: "Public LinkedIn pages (via search results)" },
  { key: "facebook", label: "Public Facebook pages/posts (via search results)" },
  { key: "instagram", label: "Public Instagram professional pages (via search results)" },
  { key: "youtube", label: "Public YouTube pages & discussions" },
  { key: "reddit", label: "Public Reddit discussions" },
  { key: "quora", label: "Public Quora-style discussions" },
  { key: "news", label: "Public news & business articles" },
  { key: "company_directories", label: "Public company directories" },
  { key: "startup_directories", label: "Public startup/founder directories" },
  { key: "real_estate_discussions", label: "Public real-estate discussions" },
];

export const KEYWORD_TEMPLATES = {
  English: ["looking to buy property", "want to invest in property", "best place to invest in property", "looking for investment property",
    "property investment opportunity", "commercial property investment", "land investment", "plot investment", "luxury property buyer",
    "second home investment", "rental income property", "high return property investment", "NRI property investment India",
    "Ayodhya property investment", "Ayodhya plots for investment", "property near Ram Mandir", "seeking property consultant",
    "looking for real estate broker", "where should I invest in property", "want to diversify into real estate"],
  Hindi: ["मकान खरीदना है", "प्लॉट खरीदना है", "प्रॉपर्टी में निवेश करना है", "अयोध्या में प्रॉपर्टी", "अयोध्या में प्लॉट", "निवेश के लिए जमीन"],
  Hinglish: ["property kharidni hai", "plot me investment", "Ayodhya me property investment", "commercial property chahiye", "plot kharidna hai", "zameen me invest karna hai"],
};

export const INTENT_CATEGORIES = ["Actively looking", "Strong investment interest", "General investment interest", "Future possibility",
  "Professional intermediary", "Irrelevant", "Unclear"];
export const TEMPERATURES = ["Hot", "Warm", "Cold", "Review", "Rejected"];
export const STATUSES = ["New", "Contacted", "Qualified", "Irrelevant", "Duplicate"];
export const VERIFICATION = ["Unverified", "Verified", "Needs review"];
export const FIN_DISCLAIMER = "Estimated from public professional and business signals; not verified personal wealth.";
